// src/pages/DriverSuccess.jsx
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import bgTaxi from "../assets/bg-taxi.png"; // ✅ same background as homepage
import "../global.css"; // ✅ reuse shared styling

const DriverSuccess = () => {
  const location = useLocation();
  const [refCode, setRefCode] = useState(null);

  useEffect(() => {
    if (location.state?.ref_code) {
      setRefCode(location.state.ref_code);
      localStorage.setItem("driverRefCode", location.state.ref_code);
    } else {
      const stored = localStorage.getItem("driverRefCode");
      if (stored) setRefCode(stored);
    }
  }, [location.state]);

  return (
    <div
      className="hero-section"
      style={{
        background: `url(${bgTaxi}) center/cover no-repeat`,
        minHeight: "85vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Dark overlay for better text contrast */}
      <div
        className="hero-overlay"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          padding: "2rem",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: "12px",
            padding: "2rem 3rem",
            maxWidth: "600px",
            width: "100%",
            boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
            textAlign: "center",
          }}
        >
          <h2 style={{ color: "#28a745", marginBottom: "1rem" }}>
            ✅ Registration Complete
          </h2>
          <p>
            Thank you for registering as a driver with <b>CheapCabGrab</b>.
          </p>

          {refCode && (
            <p
              style={{
                fontWeight: "bold",
                marginTop: "1rem",
                fontSize: "18px",
                color: "#d35400",
              }}
            >
              Your driver reference: {refCode}
            </p>
          )}

          <p style={{ marginTop: "1rem", color: "#555" }}>
            Our team will review your details and get in touch soon.
          </p>

          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
            }}
          >
            <Link
              to="/"
              style={{
                padding: "12px 24px",
                background: "#ffc107",
                color: "#000",
                borderRadius: "6px",
                textDecoration: "none",
                fontWeight: "600",
              }}
            >
              ⬅ Back to Home
            </Link>

            <Link
              to="/contact"
              style={{
                padding: "12px 24px",
                background: "#007bff",
                color: "#fff",
                borderRadius: "6px",
                textDecoration: "none",
                fontWeight: "600",
              }}
            >
              📞 Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverSuccess;

